import Api from '@/api/api.js'

export default {
    /**
     * Liste des inventaires
     */
    inventaires (params = {}) {
        const promise = Api().get('/inventaires', { params })
        return promise.then((response) => response.data)
    },

    /**
     * Recuperer un inventaire
     */
    getInventaire (id) {
        const promise = Api().get('/inventaire/' + id)
        return promise.then((response) => response.data)
    },

    /**
     * Enregistrer un inventaire
     */
    saveInventaire (data) {
        const promise = Api().post('/inventaire', data)
        return promise.then((response) => response.data)
    },

    demanderInventaire (data) {
        const promise = Api().post('/inventaire/demande', data)
        return promise.then((response) => response.data)
    },

    produitsStock (stockId) {
        const promise = Api().get('/inventaire/stock/' + stockId + '/produits')
        return promise.then((response) => response.data)
    },

    updateResultats (id, data) {
        const promise = Api().put('/inventaire/' + id + '/resultats', data)
        return promise.then((response) => response.data)
    },

    soumettreInventaire (id, utilisateur_id) {
        const promise = Api().put('/inventaire/' + id + '/soumettre', { utilisateur_id: utilisateur_id })
        return promise.then((response) => response.data)
    },

    autoriserCorrection (id) {
        const promise = Api().put('/inventaire/' + id + '/autoriser-correction')
        return promise.then((response) => response.data)
    },

    saveObservation (id, data) {
        const promise = Api().put('/inventaire/' + id + '/observation', data)
        return promise.then((response) => response.data)
    },

    retablirInventaire (id) {
        const promise = Api().put('/inventaire/' + id + '/retablir')
        return promise.then((response) => response.data)
    },

    deleteInventaire (id) {
        const promise = Api().delete('/inventaire/' + id)
        return promise.then((response) => response.data)
    },

    getListeInventaire (data) {
        const promise = Api().post('/inventaires', data)
        return promise.then((response) => response.data)
    },
}
